import { updateLabels } from "store/actions/forms-action";
import { AppDispatch } from "store/store";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default () => {
    const dispatch: AppDispatch = useDispatch()
    const navigate = useNavigate();

    const { selected_section, labels, forms_loading } = useSelector((state: any) => state.forms)

    const [selectedTab, setSelectedTab] = useState<any>(selected_section?.screens?.[0]);
    const [showModal, setShowModal] = useState<boolean>(false);

    const onChangeLabel = (val, label) => {
        const obj = { ...selectedTab?.labels }
        obj[label] = val
        setSelectedTab({ ...selectedTab, labels: obj })
    }

    const onPressSave = () => {

        let sections = [...labels]

        let section_index = sections?.findIndex(val => val?.sectionKey === selected_section?.sectionKey)
        
        if (section_index === -1) return

        let section = sections[section_index]

        const updatedScreens = section?.screens?.map((screen: any) => screen.key === selectedTab?.key ? selectedTab : screen);

        sections[section_index] = { ...section, screens: updatedScreens };

        dispatch(updateLabels({ sections }, () => setShowModal(true)))
    }

    return {
        selectedTab,
        setSelectedTab,
        navigate,
        showModal,
        setShowModal,
        selected_section,
        onChangeLabel,
        onPressSave,
        forms_loading
    }

}